import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/extract`, {params: {...filter}})
  },

}